import { createDirectus } from '@directus/sdk';
import { rest, createUser, login  } from '@directus/sdk';
import { authentication } from '@directus/sdk';
 
//const client = createDirectus('http://localhost:8055').with(rest()).with(authentication('json'));
const client = createDirectus('http://localhost:8055').with(rest()).with(authentication('json'));


export default client;